import Helper from "../Helper";

/**
 * Represents room settings modal with toggle.
 */
export default class RoomSettings {

  /**
   * Constructor.
   *
   * @param {String} name
   * @param {Search} context for search term preview update
   */
    constructor(name, context)
    {
        this.context = context;
        this.name = name;
        this.toggle = $('[data-room-settings-toggle="' + name + '"]');
        this.modalWrapper = $('[data-room-settings-wrapper="' + name +'"]');
        this.initWidth = $(window).width();

        this.init();
    }

  /**
   * Initialise the rooms settings toggling
   */
    init()
    {

        // Toggling modal
        this.toggle.click((event) => {
            let $clickedElement = $(event.target);

            if (!this.modalWrapper.is(':visible')) {
                // If is respo active and already respo modal is opened
                if (this.context.canToggleAction()) {
                    this.context.deactivateAllActions();
                    this.modalWrapper.css('display', 'block');
                    this.toggle.closest('[data-activable]').addClass('active');

                    this.resize();
                } else {
                    this.context.openRespoModal([this.toggle]);
                }
            } else if (
            (
            !$clickedElement.closest('[data-room-settings]').length
            && !$clickedElement.closest('[data-room-settings-wrapper]').length
            && !Helper.isBigMobileOrLower()
            )
            ||
            typeof $clickedElement.data('close') !== 'undefined'
            ||
            typeof $clickedElement.data('save') !== 'undefined'
        ) {
            this.close();
            this.context.hideRespoModal();
            }
        });

      /**
       * Registering observers
       */
        window.documentClickObserve.register(this.documentClickClosing.bind(this));
        window.windowResizeObserve.register(this.windowResizeCallback.bind(this));

      /**
       * Adding adults,rooms,children or medical treatment
       */
        this.modalWrapper.find('[data-quantity="plus"]').click((e) => {
            e.preventDefault();
            this.handleContentAdding($(e.target).closest('[data-quantity="plus"]'));
        });

      /**
      * Removing adults, rooms or children
      */
        this.modalWrapper.find('[data-quantity="minus"]').click((e) => {
            e.preventDefault();
            this.handleContentRemoving($(e.target).closest('[data-quantity="minus"]'));
        });
    }

/**
 * This function handles clicking on adding buttons.
 *
 * @param {Element|String} element
 *
 * @returns
 */
    handleContentAdding(element)
    {
        let $element = $(element);
        let fieldName = $element.attr('data-field');
        let $translations = $("#translations");
        let selectAgeTrans = $translations.attr('data-age-trans');
        let yearTransZero = $translations.attr('data-year-trans-zero');
        let yearTrans = $translations.attr('data-year-trans');
        let yearTwoTrans = $translations.attr('data-year-two-trans');
        let yearsTrans = $translations.attr('data-years-trans');
        let adultsTrans = $translations.attr('data-adults-trans');
        let childrenTrans = $translations.attr('data-children-trans');
        let roomTrans = $translations.attr('data-room-trans');
        let addRoomTrans = $translations.attr('data-add-room-trans');
        let removeRoomTrans = $translations.attr('data-remove-room-trans');
        let $parent = undefined;
        let currentVal = undefined;

        // Parent is wrapper for one room with its adults + children
        if (fieldName === "searchroom" || fieldName === "searchadult" || fieldName === "searchchild") {
            $parent = $element.closest('.plus-minus-wrapper');
        } else {
            $parent = $element.closest('.plus-minus-wrapper-details');
        }

        let elemInput = $parent.find($('input[name=' + fieldName + ']'));
        let counterForOtherSearch = $($parent).data('counterForSearches');

        let $otherSearchParent = this.getOtherSearchParent(counterForOtherSearch, $parent);

        // Current value is value of the element
        if (elemInput.length <= 0) {
            elemInput = $parent.find($('[data-field-name=' + fieldName + ']'));
            currentVal = parseInt(elemInput.text());
        } else {
            currentVal = parseInt(elemInput.val());
        }
        let newVal = currentVal + 1;

        if (fieldName !== 'searchroom' && fieldName !== 'availroom' && newVal > 8) {
            return;
        }

        let countRoomsAvail = 1;
        if (fieldName === 'availroom') {
            $($parent).find('[data-quantity="minus"]').removeClass('hidden-mvio');

            $($otherSearchParent).find('[data-quantity="minus"]').removeClass('hidden-mvio');

            countRoomsAvail = this.modalWrapper.find('[data-room-settings]').length + 1;
        }

        let ageCounter = undefined;

        if (fieldName === 'searchchild' || fieldName === 'avalchild') {
            ageCounter = newVal;
            let selectsCounter = this.modalWrapper.find('[data-select-counter]').length + 1;

            if (ageCounter > 0) {
                $parent.find($('.children-ages-scroller')).css({"display": "inline-block"});
                let html = this.getChildHtml(fieldName, ageCounter, selectAgeTrans, yearTransZero, yearTrans, yearTwoTrans, yearsTrans, selectsCounter, $($parent).data('roomSettings'));
                let htmlForOtherSearch = this.getChildHtml(fieldName === 'avalchild' ? 'searchchild' : 'avalchild', ageCounter, selectAgeTrans, yearTransZero, yearTrans, yearTwoTrans, yearsTrans, selectsCounter, $($parent).data('roomSettings') === 'rooms' ? 'main' : 'rooms');
                $parent.find('.children-ages-wrapper').append(html);
                $($otherSearchParent).find('.children-ages-wrapper').append(htmlForOtherSearch);
            } else {
                $parent.find($('.children-ages-scroller')).css({"display": "none"});
            }
        }

        if (isNaN(currentVal)) {
            let plusIcon = $('[name="plus_icon"]').val();
            let minusIcon =  $('[name="minus_icon"]').val();
            let newSetting = this.getHtmlForNewSetting($($parent).data('roomSettings'), countRoomsAvail, roomTrans, adultsTrans, minusIcon, plusIcon, childrenTrans, removeRoomTrans, addRoomTrans);
            let newSettingForSecondSearch = this.getHtmlForNewSetting($($parent).data('roomSettings') === "rooms" ? "main" : "rooms", countRoomsAvail, roomTrans, adultsTrans, minusIcon, plusIcon, childrenTrans, removeRoomTrans, addRoomTrans);

            newSetting.find('[data-quantity="plus"]').click((e) => {
                e.preventDefault();
                this.handleContentAdding($(e.target).closest('[data-quantity="plus"]'));
            });

            newSetting.find('[data-quantity="minus"]').click((e) => {
                e.preventDefault();
                this.handleContentRemoving($(e.target).closest('[data-quantity="minus"]'));
            });

            newSettingForSecondSearch.find('[data-quantity="plus"]').click((e) => {
                e.preventDefault();
                this.handleContentAdding($(e.target).closest('[data-quantity="plus"]'));
            });

            newSettingForSecondSearch.find('[data-quantity="minus"]').click((e) => {
                e.preventDefault();
                this.handleContentRemoving($(e.target).closest('[data-quantity="minus"]'));
            });

            this.modalWrapper.find(".rooms-save-room").before(newSetting);

            // wrapper
            $($otherSearchParent).parent().find(".rooms-save-room").before(newSettingForSecondSearch);
        }

        if (fieldName !== "searchroom" && fieldName !== "availroom") {
            $parent.find('[data-field-name=' + fieldName + ']').text(newVal);
            $($otherSearchParent).find('[data-field-name=' + fieldName + ']').text(newVal);
        }

        window.setsearchhotelfield(this.modalWrapper);
    }

  /**
   * This function handles clicking on removing buttons.
   *
   * @param {Element|String} element
   *
   * @returns
   */
    handleContentRemoving(element)
    {
        let $element = $(element);
        let fieldName = $element.attr('data-field');
        let counterID = $element.parents('[data-elements-counter]').first().data('elementsCounter');
        let $parent = undefined;
        let currentVal = undefined;
        $parent = $element.closest('[data-room-settings]');

        let counterForOtherSearch = $($parent).data('counterForSearches');

        let $otherSearchParent = this.getOtherSearchParent(counterForOtherSearch, $parent);

        let rootParent = $($parent).parent();
        let $otherSearchRootParent = $($otherSearchParent).parent();

        let elemInput = $parent.find($('input[name=' + fieldName + ']'));

      // Current value is value of the element
        if (elemInput.length <= 0) {
            elemInput = $parent.find($('[data-field-name=' + fieldName + ']'));
            currentVal = parseInt(elemInput.text());
        } else {
            currentVal = parseInt(elemInput.val());
        }
        let newVal = currentVal - 1;

        if (newVal < 0) {
            return;
        }

        if (fieldName === 'availroom') {
            $parent.remove();

            $($otherSearchParent).remove();

            window.elementsCounters[counterID].recalculatePositions();
            window.setsearchhotelfield(this.modalWrapper);

            if (window.elementsCounters[counterID].countElements() <= 1) {
                $(rootParent).find('[data-quantity="minus"][data-field="availroom"]').first().addClass('hidden-mvio');

                $($otherSearchRootParent).find('[data-quantity="minus"][data-field="availroom"]').first().addClass('hidden-mvio');
            }

            return;
        }

        if (fieldName === 'avalchild') {
            if (newVal > 0) {
                $parent.find($(".children-ages-scroller")).css({"display": "inline-block"});
            } else {
                $parent.find($(".children-ages-scroller")).css({"display": "none"});
            }

            $parent.find('select').last().parent().remove();

            $($otherSearchParent).find('[data-field-name=' + fieldName + ']').text(newVal);
            $($otherSearchParent).find('select').last().parent().remove();

            if (!isNaN(currentVal) && currentVal > 0) {
                $parent.find('[data-field-name="' + fieldName + '"]').text(newVal);

                $($otherSearchParent).find('[data-field-name=' + fieldName + ']').text(newVal);
            } else {
                $parent.find('[data-field-name="' + fieldName + '"]').text(0);

                $($otherSearchParent).find('[data-field-name=' + fieldName + ']').text(0);
            }

            window.setsearchhotelfield(this.modalWrapper);
            return;
        }

        if (!isNaN(currentVal) && currentVal > 0 && currentVal !== 1) {
            $parent.find('[data-field-name=' + fieldName + ']').text(newVal);
            $($otherSearchParent).find('[data-field-name=' + fieldName + ']').text(newVal);
        } else {
            $parent.find('[data-field-name=' + fieldName + ']').text(1);
            $($otherSearchParent).find('[data-field-name=' + fieldName + ']').text(1);
        }

        window.setsearchhotelfield(this.modalWrapper);
    }

  /**
   * Will close the settings.
   */
    close()
    {
        this.modalWrapper.css('display', 'none');
        this.toggle.closest('[data-activable]').removeClass('active');
        window.setsearchhotelfield(this.modalWrapper);
    }

  /**
   * Will resize wrapper height.
   */
    resize()
    {
        if (Helper.isBigMobileOrLower()) {
            let top = this.modalWrapper.offset().top - $(window).scrollTop(); // 65 is height of toggle

            if (this.modalWrapper.parents('[data-fullscreen-modal]').length > 0) {
                this.modalWrapper.css('height', ($(window).height()) - top + 'px');
            } else {
                this.modalWrapper.css('height', ($(window).height() - top - 24) + 'px');
            }
        } else {
            this.modalWrapper.css('height', '');
        }
    }

  /**
   * Will trigger after window resize.
   *
   * @see WindowResizeSubject
   */
    windowResizeCallback()
    {
        if (Helper.isBigMobileOrLower() && !this.toggle.closest('[data-respo-modal]').length && this.initWidth !== $(window).width()) {
            this.close();
        }


        if (Helper.isTabletOrHigher() && this.toggle.closest('[data-respo-modal]').length && this.initWidth !== $(window).width()) {
            this.close();
            this.context.hideRespoModal();
        }

        this.resize();
    }

  /**
   * Function that will be triggered after document click
   *
   * @see DocumentClickSubject
   *
   * @param {Element} $clickedElement jQuery element
   * @returns {Boolean}
   */
    documentClickClosing($clickedElement)
    {
        if (
        $($clickedElement).closest('[data-room-settings-toggle]').length
        ||
        $($clickedElement).closest('[data-field="availroom"]').length
        ||
        $($clickedElement).closest('[data-room-settings-wrapper]').length
        ||
        $($clickedElement).closest('[data-dim="respo-' + this.name + '"]').length
        ||
        $($clickedElement).closest('[data-respo-modal]').length
        ) {
            return false;
        }

      // If modal is opened before closing
        if (this.modalWrapper.css('display') === 'block') {
            window.setsearchhotelfield(this.modalWrapper);
        }

        this.toggle.closest('[data-activable]').removeClass('active');
        this.modalWrapper.css('display', 'none');
    }


  /**
   * Function that returns html for adding a new room
   *
   * @param {String} name search name
   * @param {Number} countRoomsAvail rooms count
   * @param {String} roomTrans translation of rooms
   * @param {String} adultsTrans translation of adults
   * @param {String} minusIcon minus button icon
   * @param {String} plusIcon plus button icon
   * @param {String} childrenTrans children translation
   * @param {String} removeRoomTrans remove room translation
   * @param {String} addRoomTrans add room translation
   *
   * @returns {String}
   */
    getHtmlForNewSetting(name, countRoomsAvail, roomTrans, adultsTrans, minusIcon, plusIcon, childrenTrans, removeRoomTrans, addRoomTrans)
    {
        return $("<div class='plus-minus-wrapper-details' data-room-settings='" + name + "' data-counter-for-searches='"+countRoomsAvail+"'>\n" +
        "                        <div class='rooms'>\n" +
        "                            <p class='rooms-count'><strong><span data-element-position>"+countRoomsAvail+"</span>° "+roomTrans+"</strong></p>\n" +
        "                        </div>\n" +
        "                        <div class='rooms'>\n" +
        "                            <div class='rooms-title-wrapper'><p class='rooms-title'>"+adultsTrans+"</p></div>\n" +
        "                            <div class='rooms-input'>\n" +
        "                                <a class='minus-btn' href='javascript:void(0)' data-quantity='minus' data-field='avaladult'>" + minusIcon + "</a>\n" +
        "                                <p class='form-control mb-0' data-field-name='avaladult'>2</p>\n" +
        "                                <a class='plus-btn' href='javascript:void(0)' data-quantity='plus' data-field='avaladult'>" + plusIcon + "</a>\n" +
        "                            </div>\n" +
        "                        </div>\n" +
        "                        <div class='rooms'>\n" +
        "                            <div class='rooms-title-wrapper'><p class='rooms-title'>"+childrenTrans+"</p></div>\n" +
        "                            <div class='rooms-input'>\n" +
        "                                <a class='minus-btn' href='javascript:void(0)' data-quantity='minus' data-field='avalchild'>" + minusIcon + "</a>\n" +
        "                                <p class='form-control mb-0' data-field-name='avalchild'>0</p>\n" +
        "                                <a class='plus-btn' href='javascript:void(0)' data-quantity='plus' data-field='avalchild'>" + plusIcon + "</a>\n" +
        "                            </div>\n" +
        "                        </div>\n" +
        "                        <div id='scrollchild' class='children-ages-scroller'>\n" +
        "                            <div class='children-ages-wrapper row'>\n" +
        "                            </div>\n" +
        "                        </div>\n" +
        "                        <div class='rooms-buttons-wrapper'><div class='rooms-remove-room'>\n" +
        "                            <a href='javascript:void(0)' class='clean' data-quantity='minus' data-field='availroom'>"+removeRoomTrans+"</a>\n" +
        "                        </div>\n" +
        "                        <div class='rooms-add-room'>\n" +
        "                            <a href='javascript:void(0)' class='clean' data-quantity='plus' data-field='availroom'>"+addRoomTrans+"</a>\n" +
        "                        </div></div>\n" +
        "                        <hr>\n" +
        "                    </div>\n" +
        "                </div>");
    }

  /**
   * Function that returns rooms for search
   *
   * @returns {[]}
   */
    getRoomPlacement()
    {
        let searchRooms = [];

        this.modalWrapper.find('.plus-minus-wrapper-details').each(function (index, item) {
            searchRooms[index] = {};
            searchRooms[index].adults = $(item).find('[data-field-name="avaladult"]').text();
            searchRooms[index].children = $(item).find('[data-field-name="avalchild"]').text();
            searchRooms[index].childrenages = $(item).find('option:selected').map(function () {
                return ($(this).val());
            }).get();
        });

        return searchRooms;
    }

  /**
   * Function that returns select for added children in room setting
   *
   * @param {String} fieldName
   * @param {String} ageCounter
   * @param {String} selectAgeTrans
   * @param {String} yearTrans
   * @param {String} yearTwoTrans
   * @param {String} yearsTrans
   * @param {Number} selectsCounter
   * @param {String} searchName
   *
   * @returns {string}
   */
  getChildHtml(fieldName, ageCounter, selectAgeTrans, yearTransZero, yearTrans, yearTwoTrans, yearsTrans, selectsCounter, searchName) {
    let html = `<div class="col-6"><select data-select-counter="${selectsCounter}" onchange="window.searches['${searchName}'].changeSelectValue(this)" class="rooms-children-select"> <option class="age_children_left"\n` +
      `value="0"\n` +
      `id="` + fieldName + `age` + ageCounter + `"\n` +
      `name="`+fieldName+`age[0]" selected>\n` +
      ``+selectAgeTrans+
      `</option>`;

        for (let i = 0; i < 18; i++) {
            let trans = yearTrans;
            if (i === 0) {
                trans = yearTransZero
            } else if (i === 1) {
                trans = yearTrans;
            } else if (i >= 2 && i <= 4) {
                trans = yearTwoTrans;
            } else {
                trans = yearsTrans;
            }

             html += '<option class="age_children_left"\n' +
                'value="' + i + '"\n' +
                'id="' + fieldName + 'age' + ageCounter + '" name="' + fieldName + 'age[]">' + i + ' ' + trans + '</option>';
        }
        html += '</select></div>';
        return html;
    }

  /**
   * Function that changes the same select in other search
   *
   * @param {Element} e changed select element
   */
    changeSelectValue(e)
    {
        let $parent = $(e).closest('[data-room-settings]');
        let counterForOtherSearch = $($parent).data('counterForSearches');

        let $otherSearchParent = this.getOtherSearchParent(counterForOtherSearch, $parent);

        let dataSelect = $(e).data('selectCounter');
        $otherSearchParent.find('[data-select-counter="'+dataSelect+'"]').val($(e).val())
    }

  /**
   * Function that returns other search parent of the same room
   *
   * @param {Number} counterForOtherSearch
   * @param {Element} parent
   *
   * @returns {Element}
   */
    getOtherSearchParent(counterForOtherSearch, parent)
    {
        if ($(parent).data('roomSettings') === "rooms") {
            return $('[data-room-settings-wrapper="main"]').find('[data-counter-for-searches="'+counterForOtherSearch+'"]');
        } else {
            return $('[data-room-settings-wrapper="rooms"]').find('[data-counter-for-searches="'+counterForOtherSearch+'"]');;
        }
    }
}
